module.exports = __webpack_public_path__ + "img/25583028b4ea608fb70aef8d6eaf091c.png";